// coupon_claim_rejected `coupon_result`: the backend rejection reasons
// (Coupon::REJECTION_REASON in photolane-backend) grouped for GA4 reports.
export const COUPON_RESULT = Object.freeze({
  INVALID: 'invalid',
  EXPIRED: 'expired',
  ALREADY_USED: 'already_used',
  NOT_ELIGIBLE: 'not_eligible',
  // No backend verdict: network failure or an older backend without `reason`.
  UNKNOWN: 'unknown',
});

const RESULT_BY_REASON = Object.freeze({
  not_found: COUPON_RESULT.INVALID,
  inactive: COUPON_RESULT.INVALID,
  invalid_referral: COUPON_RESULT.INVALID,
  expired: COUPON_RESULT.EXPIRED,
  usage_limit: COUPON_RESULT.EXPIRED,
  already_used: COUPON_RESULT.ALREADY_USED,
  launch_claimed: COUPON_RESULT.ALREADY_USED,
  wrong_products: COUPON_RESULT.NOT_ELIGIBLE,
  wrong_platform: COUPON_RESULT.NOT_ELIGIBLE,
});

export const couponResult = reason => RESULT_BY_REASON[reason] ?? COUPON_RESULT.UNKNOWN;
